import React, { useState } from 'react';
import './Form.scss';
import useForm from '../../../services/useForm';
import Translation from '../../../services/translation.service';
import Input from '../../../components/ui_elements/Input';
import Settings from '../../../services/settings.service';
import Button from '../../../components/ui_elements/Button';
import TextArea from '../../../components/ui_elements/TextArea';
import OrderService from '../../../services/order.service.js';
import Spinner from '../../../components/shared/Spinner';
import { setStorageElement } from '../../../services/storage.service';
import { ORDER_ID } from '../../../constants';
function Form(props) {
  const [loading, updateLoading] = useState(false);
  const [orderDetails, updateOrderDetails] = useState([]);
  const [showForm, updateShowForm] = useState('Corporate');

  const { state, handleChange, handleSubmit } = useForm(
    {
      formValid: false,
      email: {
        value: '',
        touched: false,
        validation: false,
        rules: [Settings.format.email],
        rulesType: 'all', //values => any | all
      },
      mobileNumber: {
        value: '',
        touched: false,
        validation: false,
        rules: [Settings.format.phoneNumberPattern],
        rulesType: 'all',
      },
      vatNumber: {
        value: '',
        touched: false,
        validation: true,
        rules: [Settings.format.notEmptyString],
        rulesType: 'all',
      },
      companyName: {
        value: '',
        touched: false,
        validation: true,
        rules: [Settings.format.notEmptyString],
        rulesType: 'all', //values => any | all
      },
      ACL: {
        value: '',
        touched: false,
        validation: true,
        rules: [Settings.format.notEmptyString],
        rulesType: 'all', //values => any | all
      },
      fullName: {
        value: '',
        touched: false,
        validation: true,
        rules: [Settings.format.notEmptyString],
        rulesType: 'all', //values => any | all
      },
    },
    () => sendRequest()
  );

  const sendRequest = () => {
    let data = {
      simDetails: props.simDetails,
      email: state.email.value,
      companyName: state.companyName.value,
      vatNumber: state.vatNumber.value,
      userType: showForm,
      mobileNumber: state.mobileNumber.value,
      acl: state.ACL.value,
    };
    try {
      OrderService.createOrder(data).then((response) => {
        if (response.status === 200) {
          updateOrderDetails(response.data);
          setStorageElement(ORDER_ID, response.data.id, 'local');
          updateLoading(false);
          props.changeOnDelivery();
        }
      });
    } catch (err) {}
  };

  let emailClasses = ['input-field', 'number-field', 'input-icon'];
  let vatNumberClasses = ['input-field', 'number-field', 'input-icon'];
  let companyNameClasses = ['input-field', 'number-field', 'input-icon'];
  let mobileNumberClasses = ['input-field', 'number-field', 'input-icon'];
  let ACLClasses = ['input-field', 'number-field', 'input-icon'];
  let fullNameClasses = ['input-field', 'number-field', 'input-icon'];

  let emailValid = true;
  if (state.email.touched) {
    emailValid = state.email.validation;
    if (state.email.value.length > 0) {
      emailClasses.push('touched');
    }
    if (!emailValid) {
      emailClasses.push('error');
    }
  }

  let fullNameValid = true;
  if (state.fullName.touched) {
    fullNameValid = state.fullName.validation;
    if (state.fullName.value.length > 0) {
      fullNameClasses.push('touched');
    }
    if (!emailValid) {
      fullNameClasses.push('error');
    }
  }

  let mobileNumberValid = true;
  if (state.mobileNumber.touched) {
    mobileNumberValid = state.mobileNumber.validation;
    if (state.mobileNumber.value.length > 0) {
      mobileNumberClasses.push('touched');
    }
    if (!mobileNumberValid) {
      mobileNumberClasses.push('error');
    }
  }

  let vatNumberValid = true;
  if (state.vatNumber.touched) {
    vatNumberValid = state.vatNumber.validation;
    if (state.vatNumber.value.length > 0) {
      vatNumberClasses.push('touched');
    }
    if (!vatNumberValid) {
      vatNumberClasses.push('error');
    }
  }

  let companyNameValid = true;
  if (state.companyName.touched) {
    companyNameValid = state.companyName.validation;
    if (state.companyName.value.length > 0) {
      companyNameClasses.push('touched');
    }
    if (!companyNameValid) {
      companyNameClasses.push('error');
    }
  }

  let error = null;
  if (props.error) {
    error = <span className="error-message">{props.error}</span>;
  }
  let content = <Spinner />;

  return (
    <div>
      <div
        className="wrapper-form"
        onChange={(e) => updateShowForm(e.target.value)}
      >
        <div className="flex-divide">
          <input
            type="radio"
            name="select"
            value={'Corporate'}
            id="corporate"
            checked={showForm === 'Corporate'}
            className={'input-b2b-radio'}
          />
          <input
            type="radio"
            name="select"
            value={'Individual'}
            id="individual"
            checked={showForm === 'Individual'}
            className={'input-b2b-radio'}
          />
          <label htmlFor="corporate" className="option corporate">
            <span>{Translation.key('b2b_corporate')}</span>
          </label>
          <label htmlFor="individual" className="option individual">
            <span>{Translation.key('b2b_individual')}</span>
          </label>
        </div>
      </div>
      {showForm === 'Corporate' && (
        <>
          <div className="form-container">
            <div className="input-field-b2b">
              <Input
                name="mobileNumber"
                type="number"
                placeholder={Translation.key('b2b_enter_mobile')}
                className={mobileNumberClasses.join(' ')}
                change={handleChange}
                value={state.mobileNumber.value}
                error={
                  (!state.mobileNumber.validation &&
                    state.mobileNumber.touched) ||
                  error
                }
              />
              {!mobileNumberValid ? (
                <span className="error-message">Wrong number</span>
              ) : null}
              {error}
            </div>

            <div className="input-field-b2b">
              <Input
                name="companyName"
                type="text"
                placeholder={Translation.key('b2b_enter_company')}
                className={companyNameClasses.join(' ')}
                change={handleChange}
                value={state.companyName.value}
                error={
                  (!state.companyName.validation &&
                    state.companyName.touched) ||
                  error
                }
              />
              {!companyNameValid ? (
                <span className="error-message">Wrong name</span>
              ) : null}
              {error}
            </div>
            <div className="input-field-b2b">
              <Input
                name="email"
                type="text"
                placeholder={Translation.key('b2b_enter_email')}
                className={emailClasses.join(' ')}
                change={handleChange}
                value={state.email.value}
                error={
                  (!state.email.validation && state.email.touched) || error
                }
              />
              {!emailValid ? (
                <span className="error-message">
                  {Translation.key('verify_email_label1.3_wrong_email')}
                </span>
              ) : null}
              {error}
            </div>
            <div className="input-field-b2b">
              <Input
                name="vatNumber"
                type="number"
                placeholder={Translation.key('b2b_enter_vat')}
                className={vatNumberClasses.join(' ')}
                change={handleChange}
                value={state.vatNumber.value}
                error={
                  (!state.vatNumber.validation && state.vatNumber.touched) ||
                  error
                }
              />

              {!vatNumberValid ? (
                <span className="error-message">
                  {Translation.key('verify_email_label1.3_wrong_email')}
                </span>
              ) : null}
              {error}
            </div>

            <div className="input-field-b2b">
              <TextArea
                name="ACL"
                type="number"
                placeholder={Translation.key('b2b_enter_acl')}
                className={ACLClasses.join(' ')}
                change={handleChange}
                value={state.ACL.value}
              />
            </div>

            <div className="button-container-b2b">
              {!loading && (
                <Button
                  type="secondary"
                  label={'Continue'}
                  disabled={!state.formValid}
                  action={handleSubmit}
                />
              )}
              {loading && content}
            </div>
          </div>
        </>
      )}{' '}
      {/*--------------------------------------------------------------------------------------*/}
      {showForm === 'Individual' && (
        <>
          <div className="form-container">
            <div className="input-field-b2b">
              <Input
                name="fullName"
                type="text"
                placeholder={Translation.key('b2b_enter_name')}
                className={fullNameClasses.join(' ')}
                change={handleChange}
                value={state.fullName.value}
              />
            </div>

            <div className="input-field-b2b">
              <Input
                name="mobileNumber"
                type="number"
                placeholder={Translation.key('b2b_enter_mobile')}
                className={mobileNumberClasses.join(' ')}
                change={handleChange}
                value={state.mobileNumber.value}
                error={
                  (!state.mobileNumber.validation &&
                    state.mobileNumber.touched) ||
                  error
                }
              />
              {!mobileNumberValid ? (
                <span className="error-message">Wrong number</span>
              ) : null}
              {error}
            </div>
            <div className="input-field-b2b">
              <Input
                name="email"
                type="text"
                placeholder={Translation.key('b2b_enter_email')}
                className={emailClasses.join(' ')}
                change={handleChange}
                value={state.email.value}
                error={
                  (!state.email.validation && state.email.touched) || error
                }
              />
              {!emailValid ? (
                <span className="error-message">
                  {Translation.key('verify_email_label1.3_wrong_email')}
                </span>
              ) : null}
              {error}
            </div>

            <div className="button-container-b2b">
              {!loading && (
                <Button
                  type="secondary"
                  label={'Continue'}
                  disabled={!state.formValid}
                  action={handleSubmit}
                />
              )}
              {loading && content}
            </div>
          </div>
        </>
      )}
      {loading && content}
    </div>
  );
}

export default Form;
